import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import brandDeterminationActions from '../actions/brandDetermination';

function getSupportedSites(store) {
    request.get(`/${config.url_prefix}/api/getSupportedSites`)
        .end((error, response) => {
            if (error) {
                store.dispatch(brandDeterminationActions.alertError('ipmob.internal.server.error'));
            } else {
                try {
                    const supportedCurrenciesAndSites = response?.body?.supportedCurrenciesAndSites;
                    if (!supportedCurrenciesAndSites) {
                        throw new Error('state=getSupportedSites - No parseable body in response');
                    }
                    store.dispatch(brandDeterminationActions.getSupportedSitesSuccess(supportedCurrenciesAndSites));
                } catch (exp) {
                    store.dispatch(brandDeterminationActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getSupportedSites;
